{
  "title": "Freedom of the Winds (HB)",
  "source": "Tal'Dorei Campaign Setting Reborn",
  "levelAndSchool": "5th-level abjuration",
  "level": 5,
  "castingTime": "1 action",
  "range": "Self",
  "components": "V, S, M (a scrap of sailcloth)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "Wind wraps around your body, tugging at your hair and clothing as your feet lift off the ground. You gain a flying speed of 60 feet. Additionally, you have advantage on ability checks to avoid being grappled, and on saving throws against being restrained or paralyzed.",
    "When you are targeted by a spell or attack while this spell is in effect, you can use a reaction to teleport up to 60 feet to an unoccupied space you can see. If this movement takes you out of range of the triggering spell or attack, you are unaffected by it. This spell then ends when you reappear."
  ],
  "spellLists": ["druid", "ranger", "sorcerer"]
}
